import React from "react"
import styled from "styled-components/macro"
import colors from "../../../scripts/colors.ts"
import ReactPlayer from "react-player/lazy"

type PropTypes = {
  vidUrl: string
}

const HomeIntroMediaStyles = styled.div``

const ReactPlayerWrap = styled.div`
  position: relative;
  padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */
  margin-bottom: 25px;
  background-color: ${colors("grey", "dk")};
`

const ReactPlayerStyles = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
`

const HomeIntroMedia: React.FC<PropTypes> = ({ vidUrl }) => {
  return (
    <HomeIntroMediaStyles>
      <ReactPlayerWrap>
        <ReactPlayerStyles url={vidUrl} width="100%" height="100%" />
      </ReactPlayerWrap>
    </HomeIntroMediaStyles>
  )
}

export default HomeIntroMedia
